import { render, staticRenderFns } from "./TableSortBy.vue?vue&type=template&id=3175d12a"
import script from "./TableSortBy.vue?vue&type=script&lang=js"
export * from "./TableSortBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports